<template>
  <b-card>
    <FormBuilder
      label="User"
      update
      :data="$store.state.user.detailData"
      :fields="fields"
      :loading-detail="$store.state.user.loadingDetail"
      :loading-submit="$store.state.user.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/user'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('user/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('user/update', { id, data })
        .then(callback)
    },
    resetData() {
      return this.$store.commit('user/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
